import {get} from '@shared/helpers/object'

import {PaymentsCardCodeType} from '@web/core/constants'

/** 결제 가능한 카드사 목록에 따라 카드를 필터링 합니다 */
export function filterCardCode<T>({
    prop,
    cards,
    availableAll,
    availableCardCodes,
}: {
    prop: keyof T
    cards: T[]
    availableAll: boolean
    // 가능 카드사 코드 목록
    availableCardCodes: string[]
}) {
    if (!availableAll) {
        const hasAvailableCardCode = (cardCode: PaymentsCardCodeType) => availableCardCodes.includes(cardCode)
        return cards.filter((card) => {
            const code: PaymentsCardCodeType = get(prop, card)
            return !!code && hasAvailableCardCode(code)
        })
    }
    return cards
}
